import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { Label, List, Header, Segment, Button, Icon } from 'semantic-ui-react'

export default class TrendingSection extends React.Component {
  onViewRecommend = (resto, restKey) => {
    const { history } = this.props

    history.push({
      pathname: `/advertisement/recommended/edit/${restKey}`,
      state: { restKey, action: 'edit', restaurant: { ...resto, key: restKey } },
    })
  }

  getRestaurantHasRecommend = () => {
    const { restaurants } = this.props
    const filterResto = {}

    _.map(restaurants, (resto, restKey) => {
      if (resto.show_recommend_items) {
        filterResto[restKey] = resto
      }
    })

    return filterResto
  }

  renderHeader = () => {
    return (
      <div>
        <Header size="large" style={{ display: 'inline-block' }}>
          Recommended
        </Header>
        <Link to="/advertisement/recommended/new" style={{ float: 'right' }}>
          <Button icon color="black">
            <Icon name="add" />
          </Button>
        </Link>
      </div>
    )
  }

  renderContent = () => {
    const restaurants = this.getRestaurantHasRecommend()

    if (_.size(restaurants) > 0) {
      const rows = _.map(restaurants, (resto, restKey) => {
        return (
          <List.Item key={restKey} style={{ padding: '10px 5px 10px 5px', color: 'black' }}>
            <List.Content
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                }}
              >
                <div>
                  <Label size="tiny" color={resto.show_recommend_items.active ? 'green' : 'red'}>
                    {resto.show_recommend_items.active ? 'Published' : 'Drafted'}
                  </Label>
                </div>
                <div style={{ marginTop: 5 }}>
                  <h4 style={{ fontWeight: 'normal' }}>
                    {resto.name}&nbsp;
                    <span style={{ color: 'darkgray' }}>
                      ({_.size(resto.recommended_items)}) recommended items
                    </span>
                  </h4>
                </div>
                <div style={{ marginTop: 5 }}>
                  <h4 style={{ fontWeight: 'normal' }}>
                    Recommended by&nbsp;
                    <span style={{ color: 'darkgray' }}>
                      {resto.show_recommend_items.recommended_by === 'editor'
                        ? "Editors"
                        : 'Restaurant'}
                    </span>
                  </h4>
                </div>
              </div>
              <div>
                <Button color="black" onClick={() => this.onViewRecommend(resto, restKey)}>
                  View
                </Button>
              </div>
            </List.Content>
          </List.Item>
        )
      })

      return (
        <div id="popular-list">
          <List divided verticalAlign="middle">
            {rows}
          </List>
        </div>
      )
    }

    return <div style={{ marginTop: 14 }}>No results</div>
  }

  render() {
    return (
      <Segment color="black">
        <div>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/advertisement/components/RecommendItem.js